export function SuggestionsCommandGroup() {
	// This component is not implemented yet.
	return null;
}
